<template>
    <div class="pa-5">
        <v-row>
            <v-col class="col-item row-title" cols="4">{{ "Client ID" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.client_id ? activeCompany.client_id : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="4">{{ "Partner payment rights" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.has_partner_payment ? "Yes" : "No" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="4">{{ "Include payer IBAN to postback" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.meta && activeCompany.meta.postback && activeCompany.meta.postback.payer_iban ? "Yes" : "No" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="4">{{ "Include payer name to postback" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.meta && activeCompany.meta.postback && activeCompany.meta.postback.payer_name ? "Yes" : "No" }}
            </v-col>
        </v-row>
        <div v-for="item in activeCompanyBanks" :key="item.bank_id">
            <div v-if="item.recipient_iban || item.recipient_name">
                <div v-if="item.name === 'Stripe' || item.name === 'Placet'">
                    <v-divider v-if="item.is_active" class="mt-3 mb-3"/>
                    <v-row v-if="item.is_active">
                        <v-col class="col-item row-title" cols="4">{{ item.name }} {{ "recipient name" | t }}</v-col>
                        <v-col class="col-item" cols="6">
                            {{ item.recipient_name ? item.recipient_name : "-" }}
                        </v-col>
                    </v-row>
                </div>
                <div v-else>
                    <v-divider class="mt-3 mb-3"/>
                    <v-row>
                        <v-col class="col-item row-title" cols="4"
                            >{{ `${item.name} ${item.country} ${t("recipient IBAN")}` }}
                        </v-col>
                        <v-col class="col-item" cols="6">
                            {{ item.recipient_iban ? item.recipient_iban : "-" }}
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="col-item row-title" cols="4"
                            >{{ `${item.name} ${item.country} ${t("recipient name")}` }}
                        </v-col>
                        <v-col class="col-item" cols="6">
                            {{ item.recipient_name ? item.recipient_name : "-" }}
                        </v-col>
                    </v-row>
                </div>
            </div>
        </div>
        <v-divider class="mt-3 mb-3"/>
        <v-row v-for="url in activeCompanyOrigins" :key="url">
            <v-col class="col-item row-title" cols="4">{{ "Access origin" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ url ? url : "-" }}
            </v-col>
        </v-row>
        <v-divider v-if="activeCompanyOrigins && activeCompanyOrigins.length > 0" class="mt-3 mb-3"/>
        <v-row v-for="iban in activeCompanyAllowedIbans" :key="iban">
            <v-col class="col-item row-title" cols="4">{{ "Allowed IBAN" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ iban ? iban : "-" }}
            </v-col>
        </v-row>
        <v-divider class="mt-3 mb-3" v-if="activeCompanyAllowedIbans && activeCompanyAllowedIbans.length > 0"/>
        <v-row>
            <v-col class="col-item row-title" cols="4">{{ "Use embedded flow for Swedbank payments" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.meta && activeCompany.meta.embedded && activeCompany.meta.embedded.payment && activeCompany.meta.embedded.payment.swedbank ? "Yes" : "No" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="4">{{ "Use embedded flow for Swedbank bulk payments" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.meta && activeCompany.meta.embedded && activeCompany.meta.embedded.bulk_payment && activeCompany.meta.embedded.bulk_payment.swedbank ? "Yes" : "No" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="4">{{ "Use embedded flow for LHV payments" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.meta && activeCompany.meta.embedded && activeCompany.meta.embedded.payment && activeCompany.meta.embedded.payment.lhv ? "Yes" : "No" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="4">{{ "Use embedded flow for LHV bulk payments" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.meta && activeCompany.meta.embedded && activeCompany.meta.embedded.bulk_payment && activeCompany.meta.embedded.bulk_payment.lhv ? "Yes" : "No" }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "integration-info-view-tab",
    computed: {
        ...mapState(["activeCompany", "activeCompanyBanks", "activeCompanyOrigins", "activeCompanyAllowedIbans"])
    },
    mounted() {}
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
